import { FlowType } from "@redotech/redo-model/return-flow";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { DeliveryWithinState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/delivery-within";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const DeliveryWithinDetails = memo(function DeliveryWithinDetails({
  state,
  setState,
  disabled,
  flowType,
}: ConditionTypeDetailsProps<DeliveryWithinState>) {
  return (
    <Flex dir="column" gap="xs">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        Max days
      </Text>
      <RedoTextInput
        min={0}
        placeholder="Enter number of days..."
        setValue={setState}
        state={disabled ? "readonly" : "default"}
        value={state}
      />
      {(flowType === FlowType.FINALIZE_RETURN ||
        flowType === FlowType.FINALIZE_CLAIM) && (
        <Text fontSize="xxs" fontWeight="regular" textColor="tertiary">
          If any selected item was not delivered within this number of days, the
          condition will not match
        </Text>
      )}
    </Flex>
  );
});
